import React from 'react';
import { Container, Accordion } from '../design-system';

export function FAQ() {
  const faqs = [
    {
      id: '1',
      title: 'Quanto tempo leva para desenvolver um projeto?',
      content: 'O tempo varia de acordo com a complexidade. Projetos simples como landing pages podem levar de 2 a 4 semanas, enquanto aplicações mais complexas podem levar de 2 a 6 meses. Fornecemos um cronograma detalhado após a análise inicial do projeto.'
    },
    {
      id: '2',
      title: 'Vocês oferecem suporte após a entrega?',
      content: 'Sim! Todos os nossos planos incluem suporte técnico após a entrega. O período varia de acordo com o plano escolhido (30, 90 dias ou contínuo no plano Enterprise). Também oferecemos contratos de manutenção mensal para suporte estendido.'
    },
    {
      id: '3',
      title: 'Quais tecnologias vocês utilizam?',
      content: 'Trabalhamos com tecnologias modernas e comprovadas como React, Next.js, TypeScript, Node.js, Python, PostgreSQL, MongoDB, AWS e Azure. Escolhemos a stack mais adequada para cada projeto baseado nos requisitos específicos.'
    },
    {
      id: '4',
      title: 'Como funciona o processo de desenvolvimento?',
      content: 'Seguimos uma metodologia ágil com sprints quinzenais. Iniciamos com uma fase de descoberta e planejamento, seguida pelo desenvolvimento iterativo com entregas frequentes. Você terá acesso a demonstrações regulares e poderá dar feedback durante todo o processo.'
    },
    {
      id: '5',
      title: 'Vocês trabalham com projetos internacionais?',
      content: 'Sim, atendemos clientes no Brasil e no exterior. Nossa equipe está preparada para trabalhar em diferentes fusos horários e temos experiência em projetos internacionais com comunicação em português e inglês.'
    },
    {
      id: '6',
      title: 'O que está incluído no preço?',
      content: 'Nossos preços incluem todo o desenvolvimento, testes, documentação técnica, treinamento básico e o período de suporte especificado. Hospedagem e domínio podem estar inclusos dependendo do plano. Custos adicionais como serviços de terceiros (APIs pagas, etc.) são sempre comunicados previamente.'
    }
  ];

  return (
    <section id="faq" className="py-20 bg-white">
      <Container maxWidth="lg">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Tire suas dúvidas sobre nossos serviços e processos.
          </p>
        </div>

        <Accordion items={faqs} />
      </Container>
    </section>
  );
}
